var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppDialog",
    {
      attrs: {
        activatorText: "Confirm",
        title: "Anonymization Configuration Sample",
        action: "Finish Upload",
        noLimitWidth: true,
        disabled:
          !_vm.trialCenterId ||
          !(_vm.datasets.size > 0 || _vm.encapsulatedDatasets.size > 0),
        hint: _vm.hint
      },
      on: {
        action: function($event) {
          return _vm.handleUploadClick()
        },
        dialog: _vm.filterDatasets
      }
    },
    [
      _c(
        "v-carousel",
        {
          staticClass: "pl-2 pr-2",
          attrs: {
            "hide-delimiter-background": "",
            light: "",
            height: "auto",
            "show-arrows": _vm.filteredDataset.length > 1,
            "show-arrows-on-hover": ""
          },
          model: {
            value: _vm.index,
            callback: function($$v) {
              _vm.index = $$v
            },
            expression: "index"
          }
        },
        [
          _vm._l(_vm.filteredDataset, function(dataset) {
            return _c(
              "v-carousel-item",
              { key: dataset.getFileName() + dataset.getPatientId() },
              [
                _c(
                  "v-simple-table",
                  {
                    staticClass: "pb-15",
                    attrs: { "fixed-header": "", height: "300" }
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", {
                          staticClass: "text-left",
                          domProps: { textContent: _vm._s("Element") }
                        }),
                        _vm._v(" "),
                        _c("th", {
                          staticClass: "text-left",
                          domProps: { textContent: _vm._s("Original Value") }
                        }),
                        _vm._v(" "),
                        _c("th", {
                          staticClass: "text-left",
                          domProps: { textContent: _vm._s("Anonymized to") }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.filterConfigItems(dataset), function(
                        configItem
                      ) {
                        return _c("tr", { key: configItem.elementName }, [
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(configItem.elementName)
                            }
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(
                                dataset.getElementFromConfig(configItem) || ""
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.anonymizeElement(
                                  configItem,
                                  dataset,
                                  _vm.patientVariableValues,
                                  _vm.configItems,
                                  _vm.constants
                                )
                              )
                            }
                          })
                        ])
                      }),
                      0
                    )
                  ]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.encapsulatedDatasets.values(), function(dataset) {
            return _c(
              "v-carousel-item",
              { key: dataset.getFileName() + dataset.getPatientId() },
              [
                _c(
                  "v-simple-table",
                  {
                    staticClass: "pb-15",
                    attrs: { "fixed-header": "", height: "300" }
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", {
                          staticClass: "text-left",
                          domProps: { textContent: _vm._s("Element") }
                        }),
                        _vm._v(" "),
                        _c("th", {
                          staticClass: "text-left",
                          domProps: { textContent: _vm._s("Anonymized to") }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.encapsulatedConfigItems, function(
                          configItem
                        ) {
                          return _c("tr", { key: configItem.elementName }, [
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(configItem.elementName)
                              }
                            }),
                            _vm._v(" "),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.anonymizeElement(
                                    configItem,
                                    dataset,
                                    _vm.encapsulatedPatientVariableValues,
                                    _vm.encapsulatedConfigItems
                                  )
                                )
                              }
                            })
                          ])
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.encapsulatedFileItems, function(item) {
                          return _c("tr", { key: item }, [
                            _c("td", {
                              domProps: { textContent: _vm._s(item) }
                            }),
                            _vm._v(" "),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  dataset.getElementFromName(item) || ""
                                )
                              }
                            })
                          ])
                        }),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            domProps: { textContent: _vm._s("DocumentTitle") }
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: { textContent: _vm._s(_vm.setDocTitle()) }
                          })
                        ])
                      ],
                      2
                    )
                  ]
                )
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }